import { useId } from "react";

const useSafeId = (prefix?: string) => {
  const id = useId().replace(/[^a-zA-Z0-9]/g, "");
  return prefix ? `${prefix}-${id}` : id;
};

export default useSafeId;
